import React from "react";
import { Box, Card, Skeleton } from "@mui/material";

const OrderSummarySkeleton = () => {
  return (
    <Box sx={{ px: 2, py: 1, paddingTop: "100px" }}>

      {/* Order ID + Date */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Skeleton variant="text" width={180} height={20} />
        <Skeleton variant="text" width={90} height={20} />
      </Box>

      {/* Product Count Banner */}
      <Box
        sx={{
          bgcolor: "#EEF7F2",
          borderRadius: "12px",
          p: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 2,
        }}
      >
        <Skeleton variant="circular" width={34} height={34} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width={60} height={16} />
          <Skeleton variant="text" width={140} height={18} />
        </Box>
      </Box>

      {/* Product Card Skeleton */}
      <Card
        elevation={0}
        sx={{ borderRadius: "18px", p: 2, mb: 2, border: "1px solid #E3E6EB" }}
      >
        {[1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              py: 1.2,
              borderBottom: i < 2 ? "0.5px solid #E3E6EB" : "none",
              "&:first-of-type": { pt: 0 },
              "&:last-of-type": { pb: 0 },
            }}
          >
            <Box display="flex" gap={1.5}>
              <Skeleton variant="rounded" width={68} height={48} />
              <Box>
                <Skeleton variant="text" width={120} height={18} />
                <Skeleton variant="text" width={60} height={16} sx={{ mt: 0.5 }} />
                <Skeleton variant="text" width={100} height={16} sx={{ mt: 0.5 }} />
              </Box>
            </Box>
            <Skeleton variant="text" width={55} height={22} />
          </Box>
        ))}

        {/* Location Box Skeleton */}
        <Box
          sx={{
            mt: 2,
            bgcolor: "#F0F8F4",
            borderRadius: "10px",
            p: 1.5,
            display: "flex",
            gap: 1,
            alignItems: "flex-start",
          }}
        >
          <Skeleton variant="circular" width={20} height={20} sx={{ flexShrink: 0, mt: 0.3 }} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={90} height={16} />
            <Skeleton variant="text" width={130} height={18} sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width={180} height={16} sx={{ mt: 0.3 }} />
          </Box>
        </Box>
      </Card>

      {/* Grand Total Skeleton */}
      <Card
        elevation={0}
        sx={{ borderRadius: "16px", border: "1px solid #E3E6EB", p: 2, mb: 2 }}
      >
        <Box display="flex" justifyContent="space-between">
          <Skeleton variant="text" width={100} height={22} />
          <Skeleton variant="text" width={70} height={22} />
        </Box>
      </Card>

      {/* Help Button Skeleton */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 1 }}>
        <Skeleton variant="rounded" width={140} height={38} sx={{ borderRadius: "8px" }} />
      </Box>

    </Box>
  );
};

export default OrderSummarySkeleton;
